import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Instagram, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const footerLinks = {
    'Platform': [
      { name: 'QFS', path: '/qfs' },
      { name: 'Web3', path: '/web3' },
      { name: '401(k)', path: '/401k' },
      { name: 'Trump Gold Card', path: '/trump-gold-card' },
    ],
    'Services': [
      { name: 'Medbed', path: '/medbed' },
      { name: 'Card Application', path: '/card-application' },
      { name: 'Contact', path: '/contact' },
    ],
    'Company': [
      { name: 'About Us', path: '/' },
      { name: 'Careers', path: '/' },
      { name: 'Privacy Policy', path: '/' },
      { name: 'Terms of Service', path: '/' },
    ],
  };

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Instagram, href: '#', label: 'Instagram' },
  ];

  return (
    <footer className="bg-[#0B2A4A] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-[#FFD700] to-[#FFD700]/80 rounded-lg flex items-center justify-center">
                <span className="text-[#0B2A4A] font-bold text-xl">F</span>
              </div>
              <span className="text-xl font-bold">Quantum Finance Guide</span>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Exploring next-generation financial infrastructure, decentralized technology, and emerging digital ecosystems.
            </p>
            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-gray-300 hover:text-[#FFD700] transition-colors duration-300">
                <Mail className="w-5 h-5" />
                <span>support@quantumfinanceguide.ltd</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300 hover:text-[#FFD700] transition-colors duration-300">
                <Phone className="w-5 h-5" />
                <span>On Demand</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300 hover:text-[#FFD700] transition-colors duration-300">
                <MapPin className="w-5 h-5" />
                <span>New York</span>
              </div>
            </div>
          </div>

          {/* Links Sections */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-lg font-semibold mb-4 text-[#FFD700]">{category}</h3>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-gray-300 hover:text-[#FFD700] transition-colors duration-300 hover:translate-x-1 inline-block transform"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Copyright */}
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} FinTech. All rights reserved.
            </p>

            {/* Social Links */}
           
          </div>
        </div>
      </div>
    </footer>
  );
};
